import React from 'react';

const WarehouseIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="19"
      height="19"
      viewBox="0 0 19 19"
      fill="none"
    >
      <path
        d="M2.0957 17H17.0957"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.80859 17L2.8461 7.97743C2.8461 7.51993 3.06359 7.08497 3.42359 6.79997L8.67359 2.71246C9.21359 2.29246 9.9711 2.29246 10.5186 2.71246L15.7686 6.79246C16.1361 7.07746 16.3461 7.51243 16.3461 7.97743V17"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinejoin="round"
      />
      <path
        d="M12.2207 8.75H6.9707C6.3482 8.75 5.8457 9.2525 5.8457 9.875V17H13.3457V9.875C13.3457 9.2525 12.8432 8.75 12.2207 8.75Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.0957 12.6875V13.8125"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.4707 6.125H10.7207"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default WarehouseIcon;
